import React, { createContext, useState, useContext } from "react";

const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const [state, setState] = useState({
    showModal: false,
    currentModal: null,
    optionalModalProps: null,
  });

  /**
   * Opens a modal with the given type and optional props.
   * @param {string} modalType - The type of modal to display.
   * @param {object} optionalModalProps - Additional props to pass to the modal (optional).
   */
  const openModal = (modalType, optionalModalProps = {}) => {
    setState({
      showModal: true,
      currentModal: modalType,
      optionalModalProps,
    });
  };

  /**
   * Closes any open modal and resets modal-related state.
   */
  const closeModal = () => {
    setState({
      showModal: false,
      currentModal: null,
      optionalModalProps: null,
    });
  };

  return (
    <ModalContext.Provider
      value={{
        showModal: state.showModal,
        currentModal: state.currentModal,
        optionalModalProps: state.optionalModalProps,
        openModal,
        closeModal,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => useContext(ModalContext);
